import React from 'react';
import { PurchaseMethod } from '../model/interfaces';
import { ReactComponent as Amazon } from '@ui-kit/icons/amazon.svg';
import { ReactComponent as Stripe } from '@ui-kit/icons/stripe.svg';
import { ReactComponent as PayPal } from '@ui-kit/icons/paypal.svg';
import Cards from '@ui-kit/components/cards';

export default function PaymentProviderIcon(props: { option: PurchaseMethod }) {
  switch (props.option) {
    case PurchaseMethod.AMAZON:
      return <Amazon height="20px" />;
    case PurchaseMethod.PAYPAL:
      return <PayPal height="20px" />;
    case PurchaseMethod.STRIPE:
      return <Stripe height="20px" />;
    case PurchaseMethod.CARD:
      return <Cards />;
    default:
      return null;
  }
}
